import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import HeroSection from './HeroSection';
import ProductSlider from './ProductSlider';
import TaglineSection from './TaglineSection';
import ProductSection from './ProductSection';
import CorporateGifting from './CorporateGifting';
import EnterpriseSection from './EnterpriseSection';
import FAQSection from './FAQSection';
import Footer from './Footer';
import ContactModal from './ContactModal';
import ProductDetails from './ProductDetails';
import Cart from './Cart';
import OrderHistory from './OrderHistory';

function HomePage({ user, onLogout, onShowOrders, onShowAccountDashboard, triggerCartOpen, onCartOpened }) {
  const [showModal, setShowModal] = React.useState(false);
  const [selectedProductId, setSelectedProductId] = React.useState(null);
  const [showCart, setShowCart] = React.useState(false);
  const [showOrders, setShowOrders] = React.useState(false);
  const location = useLocation();

  React.useEffect(() => {
    if (triggerCartOpen) {
      setShowCart(true);
      if (onCartOpened) onCartOpened();
    }
  }, [triggerCartOpen, onCartOpened]);

  React.useEffect(() => {
    const hash = window.location.hash;
    const sessionTarget = sessionStorage.getItem('scrollToTarget');
    let targetId = null;
    if (sessionTarget) {
      targetId = sessionTarget === 'enterprise' ? 'enterprise-wrapper' : sessionTarget;
      sessionStorage.removeItem('scrollToTarget');
    } else if (hash === '#why-corgif') {
      targetId = 'why-corgif';
    } else if (hash === '#enterprise-wrapper') {
      targetId = 'enterprise-wrapper';
    }
    if (!targetId) return;
    window.history.replaceState(null, '', '/');

    // Keep scrolling until position stabilizes (content stops shifting)
    let lastTop = -1;
    let stableCount = 0;
    let attempts = 0;
    const doScroll = () => {
      const el = document.getElementById(targetId);
      if (!el) {
        if (attempts++ < 60) setTimeout(doScroll, 200);
        return;
      }
      const headerH = document.getElementById('header')?.offsetHeight || 80;
      const top = Math.max(0, el.getBoundingClientRect().top + window.scrollY - headerH - 24);
      window.scrollTo({ top, behavior: 'auto' });
      if (Math.abs(top - lastTop) < 5) {
        stableCount++;
        if (stableCount >= 3) {
          // Position stable, do final smooth scroll
          window.scrollTo({ top, behavior: 'smooth' });
          return;
        }
      } else {
        stableCount = 0;
      }
      lastTop = top;
      if (attempts++ < 60) setTimeout(doScroll, 300);
    };
    setTimeout(doScroll, 500);
  }, []);

  return (
    <div id="page" className="page">
      <Header 
        onContactClick={() => setShowModal(true)} 
        onLoginClick={() => {}}
        onCartClick={() => setShowCart(true)}
        onShowOrders={() => setShowOrders(true)}
        onShowAccountDashboard={onShowAccountDashboard}
        user={user}
        onLogout={onLogout}
        onProductClick={(product) => setSelectedProductId(product.id)}
      />
      <HeroSection />
      <ProductSlider />
      <TaglineSection />
      <ProductSection 
        id="standard" 
        title="Standard Options" 
        tagline="Approachable • Practical • Reliable"
        titleClass="section-title"
        onProductClick={setSelectedProductId}
      />
      <ProductSection 
        id="premium" 
        title="Premium Options" 
        tagline="Refined • Curated • Brand-Focused"
        titleClass="section-title premium-title"
        bgClass="bg-light"
        onProductClick={setSelectedProductId}
      />
      <ProductSection 
        id="super-premium" 
        title="Super-Premium Options" 
        tagline="Exclusive • Experiential • Statement-Making"
        titleClass="section-title super-premium-title"
        onProductClick={setSelectedProductId}
      />
      <CorporateGifting id="why-corgif" />
      <FAQSection />
      <div id="enterprise-wrapper">
        <EnterpriseSection />
      </div>
      <Footer />
      <ContactModal show={showModal} onClose={() => setShowModal(false)} />
      <ProductDetails productId={selectedProductId} onClose={() => setSelectedProductId(null)} onProductClick={setSelectedProductId} onGoToCart={() => { setSelectedProductId(null); setShowCart(true); }} />
      {showCart && <Cart onClose={() => setShowCart(false)} />}
      {showOrders && <OrderHistory userId={user?.userId} onClose={() => setShowOrders(false)} />}
    </div>
  );
}

export default HomePage;
